import { render } from "./reportesrestaurante.vue?vue&type=template&id=440cbd68&scoped=true"
import script from "./reportesrestaurante.vue?vue&type=script&lang=js"
export * from "./reportesrestaurante.vue?vue&type=script&lang=js"

import "./reportesrestaurante.vue?vue&type=style&index=0&id=440cbd68&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-440cbd68"]])

export default __exports__